import $ from 'jquery';

var locationinput = 'birth_place';
var autocomplete;

$(document).ready(function () {
    // Find the script tag generated by Complianz
    var googleMapsScript = $('#google-maps-js');
    if (googleMapsScript.length) {
        // Create a new script element
        var script = document.createElement('script');
        script.src = googleMapsScript.data('cmplz-src');
        script.async = true;
        script.defer = true;

        // Append the new script to the head
        document.head.appendChild(script);

        // Remove the old script tag
        googleMapsScript.remove();

        // Set an onload callback to ensure the Google Maps API is fully loaded
        script.onload = function () {
            initializeAutocomplete();
        };
    } else {
        // If the script tag is not found, initialize immediately (for development purposes)
        initializeAutocomplete();
    }
});

function initializeAutocomplete() {
    if ($('#' + locationinput).length) {
        autocomplete = new google.maps.places.Autocomplete((document.getElementById(locationinput)), {
            types: ['geocode'],
        });

        // Check if the input field is not empty on page load
        var inputValue = $('#' + locationinput).val();
        if (inputValue !== '') {
            // Use the Google Geocoding API to get the location details
            geocodePlace(inputValue, function (result) {
                if (result) {
                    var latElement = document.getElementById('loc_lat');
                    var longElement = document.getElementById('loc_long');

                    // Check if the elements exist before setting values
                    if (latElement && longElement) {
                        latElement.value = result.geometry.location.lat();
                        longElement.value = result.geometry.location.lng();
                    }
                }
            });
        }

        // Listen for place_changed event
        google.maps.event.addListener(autocomplete, 'place_changed', function () {
            updateLatLngFields();
        });
    }
}

function updateLatLngFields() {
    var near_place = autocomplete.getPlace();
    if (near_place && near_place.geometry && near_place.geometry.location) {
        var latElement = document.getElementById('loc_lat');
        var longElement = document.getElementById('loc_long');

        // Check if the elements exist before setting values
        if (latElement && longElement) {
            latElement.value = near_place.geometry.location.lat();
            longElement.value = near_place.geometry.location.lng();
        }
    }
}

function geocodePlace(place, callback) {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'address': place }, function (results, status) {
        if (status === 'OK' && results.length > 0) {
            callback(results[0]);
        } else {
            console.error('Error geocoding place:', status);
            callback(null);
        }
    });
}

// Additional code to directly set lat and long when birth_place input changes
$(document).on('input', '#' + locationinput, function () {
    var inputValue = $('#' + locationinput).val();
    if (inputValue !== '') {
        geocodePlace(inputValue, function (result) {
            if (result) {
                var latElement = document.getElementById('loc_lat');
                var longElement = document.getElementById('loc_long');

                // Check if the elements exist before setting values
                if (latElement && longElement) {
                    latElement.value = result.geometry.location.lat();
                    longElement.value = result.geometry.location.lng();
                }
            }
        });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/partials/location.js